
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import vietnami from "../../assets/vietnami.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function VietnamiMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Vietnámi magyar fordító</title>
                <meta name='description' content="Ingyenes vietnámi magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Vietnámi magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/vietnami-magyar-fordito" />
            </Helmet>
            <h1>Vietnámi magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A vietnámi nyelvről</h2>
                    <img src={vietnami} alt="Vietnámi zászló"></img>
                </div>

                <p>A vietnami Vietnam hivatalos nyelve, és körülbelül 90 millióan beszélik. Ez egy tonális nyelv, amely az ausztroázsiai nyelvcsaládhoz tartozik, és jellegzetes hangnemeiről, gazdag nyelvtörténetéről és kulturális jelentőségéről ismert.</p>

                <p>Írásrendszere a latin ábécé módosított változatát használja további diakritikus jelekkel. 29 betűből áll, beleértve a đ, ê, ơ, ư és ả karaktereket. A vietnami kiejtést hat hangszín jellemzi, amelyek megkülönböztetik a szavak jelentését. A pontos tonális kiejtés elengedhetetlen a tiszta vietnami kommunikációhoz.</p>

                <p>A vietnami nyelvtan viszonylag egyszerűnek tűnik, mert nincs benne sok ragozás. Ez egy alany-ige-tárgy (SVO) nyelv, ami azt jelenti, hogy az alapvető mondatszerkezet ezt a sorrendet követi. A főnevek általában ragozatlanok, a többes számokat pedig kontextus vagy konkrét szavak jelzik. Az igék az időtől függetlenül ugyanazok maradnak, az igeidőket pedig időjelzők jelzik.</p>

                <p>A vietnami szókincs az ausztroázsiai nyelvcsaládban gyökerezik, de kölcsönzött szavakat kínai, francia és angol nyelvből is. A vietnami irodalom hosszú múltra tekint vissza, olyan nevezetes költőkkel és írókkal, mint Nguyễn Du, Hồ Xuân Hương és Nguyễn Ngọc Ngạn. A vietnami kultúra mélyen összefonódik nyelvével, a hagyományokkal, a népzenével és a konyhával, amely tükrözi az ország gazdag örökségét.</p>

                <p>Vietnam gazdasága növekvőben van, különösen az olyan ágazatokban, mint a gyártás, a technológia, a turizmus és a mezőgazdaság. A vietnami nyelv ismerete előnyös lehet ezeken a területeken végzett karrierhez, vagy azoknak, akik érdeklődnek a vietnami tanulás vagy munka iránt.</p>

                <p>A vietnami nyelv megértése megkönnyíti a kommunikációt és a kulturális elmélyülést a vietnami nyelvű közösségekben. Lehetővé teszi a vietnami szokások, hagyományok és társadalmi normák mélyebb megértését. A vietnami fesztiválok, a hagyományos ruházat és a konyha az ország élénk kulturális identitását mutatják be.</p>

                <p>Ezenkívül a vietnami nyelv tanulása hozzáférést biztosít Vietnam kulturális örökségéhez és történelmi jelentőségéhez. Lehetővé teszi Vietnam ókori történelmének, lélegzetelállító tájainak és építészeti csodáinak jobb értékelését. Hanoi, Ho Si Minh-város, Halong-öböl és Hoi An felfedezése még kifizetődőbb a vietnami nyelvű kommunikáció képességével.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-vietnami-fordito">Magyar vietnámi fordító</Link>

                    <img src={vietnami} alt="vietnámi zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>


            </section>
        </>

    )
}

export default VietnamiMagyar;